import type { ISegmentsModuleState } from "app/reducers/_reducers/segmentsModuleReducer";

export const selectLimitationStatus = (state: { segmentsModule: ISegmentsModuleState }) =>
    state.segmentsModule.dashboardSegmentsMeta?.LimitationStatus;

export const selectDashboardSegments = (state: { segmentsModule: ISegmentsModuleState }) =>
    state.segmentsModule.dashboardSegmentsMeta?.Segments;
